module.exports = new __parcel__URL__("training_tab_active.a724031c.png").toString();